import PropTypes from 'prop-types';
import React from 'react';

import trainTime from '../../lib/TrainTime';
import FeatureFlagStore from '../../stores/FeatureFlagStore';
import connectToStores from '../../helpers/connectToStores';

import PureRenderComponent from '../PureRenderComponent';

const _getStateFromStores = ({ name, expires, inverse }) => {
    let flag = FeatureFlagStore.get(name);
    if (expires) {
        const expiresDate = FeatureFlagStore.get(expires);
        flag = flag && trainTime().isBefore(trainTime(expiresDate));
    }
    if (inverse) {
        flag = !flag;
    }
    return { flag };
};

@connectToStores([ FeatureFlagStore ], _getStateFromStores)
class FeatureFlag extends PureRenderComponent {

    static propTypes = {
        name: PropTypes.string.isRequired,
        children: PropTypes.node,
        disabled: PropTypes.bool,
        expires: PropTypes.string,
        inverse: PropTypes.bool,
        flag: PropTypes.bool,
        className: PropTypes.string
    };

    static defaultProps = {
        inverse: false,
        disabled: false,
        expires: null,
        className: null
    };

    render () {
        const { disabled, children, flag, className } = this.props;

        if (disabled || !flag || !children) {
            return null;
        }

        if (React.Children.count(children) === 1) {
            return children;
        }

        return <div className={ className }>{ children }</div>;
    }

}


export default FeatureFlag;
